// Kanonische Platform-Environments (Spiegel von backend/app/core/platform_envs.py).
// Verbindliche Reihenfolge: dev, staging, prod, demo.
// 'quality' wurde zu 'staging' umbenannt; 'demo' ist neu ergaenzt.
export const PLATFORM_ENVIRONMENTS = ['dev', 'staging', 'prod', 'demo'];

export default PLATFORM_ENVIRONMENTS;
